import moment from "moment";
import { TrainingAzureSearchServices } from "./training-azure-search.services";
import { TrainingNewAzureSearchTypesConstants } from "./training-azure-search.types";

export const generalSearchDateConstant = "2001-01-01T10:57:02.444Z";

export const staticTrainingAzureSearchData = {
    "count": true,
    "skip": 0,
    "top": 10,
    "searchMode": "any",
    "queryType": "simple",
    "filter": "",
    "facets": [
        // "DisplayName,count:5,sort:count",
        "DatePublished,values:" + moment().toDate().toISOString() + "|" + moment().add(1, 'years').toDate().toISOString(),
        // "City,count:5,sort:count",
        // "State,count:5,sort:count",
        "ByFormat,count:50,sort:count",
        "ByCategory,count:50,sort:count",
        "ByIndustry,count:50,sort:count",
        "ByLocation,count:50,sort:count"
    ],
    "search": "*"
}

export const getTrainingAzureSearchData = (requestBody) => {
    // let newFilterString = requestBody.filter.length > 0
    //     ? requestBody.filter + " and RegistrationEndDate ge " + moment().toDate().toISOString()
    //     : "RegistrationEndDate ge " + moment().toDate().toISOString();

    //RP - https://sentry.io/organizations/tci-cp/issues/2719053684/?project=5967072
    let newSearchFilterString = requestBody.search !== "*" && requestBody.filter && requestBody.filter.length > 0
        ? requestBody.filter + " and (search.ismatch('" + requestBody.search + "*', 'DisplayName', 'full', 'any') or search.ismatch('" + requestBody.search + "*', 'ShortDescription', 'full', 'any') or search.ismatch('" + requestBody.search + "*', 'LongDescription', 'full', 'any'))"
        : requestBody.search !== "*" && requestBody.filter.length === 0
            ? " (search.ismatch('" + requestBody.search + "*', 'DisplayName', 'full', 'any') or search.ismatch('" + requestBody.search + "*', 'ShortDescription', 'full', 'any') or search.ismatch('" + requestBody.search + "*', 'LongDescription', 'full', 'any'))"
            : requestBody.filter.length > 0
                ? requestBody.filter + " and RegistrationEndDate ge " + moment().toDate().toISOString()
                : "RegistrationEndDate ge " + moment().toDate().toISOString()

    let trainingRequestBody = Object.assign({}, requestBody, {
        "top": 5000,
        "skip": 0,
        "filter": newSearchFilterString,
        "search": "*"
    })
    return (dispatch) => {
        TrainingAzureSearchServices.searchForGeneralData(trainingRequestBody).then(response => {
            dispatch({
                type: TrainingNewAzureSearchTypesConstants.TRAINING_NEW_LAST_SEARCH,
                payload: requestBody
            })

            dispatch({
                type: TrainingNewAzureSearchTypesConstants.TRAINING_NEW_AZURE_SEARCH,
                payload: response,
                lastQuery: requestBody
            })
        })
    }
}
